import { FC } from "react"
import { Owner } from "shared/types"
import profileImg from "shared/assets/img/user.png";
import { SearchListItem } from "shared/ui/searchList/style";
import { COLORS } from "shared/consts";
import { CheckIcon } from "shared/ui/icons/checkIcon";
import { DiaryFiltersAuthorsWrapper, DiaryFiltersItem, DiaryFiltersItemTitle } from "./styles";

type DiaryFiltersAuthorsProps = {
  authors: Owner[];
  ids: string[];
  hideHeader?: boolean;
  onAuthorClick: (id: string) => void;
}
export const DiaryFiltersAuthors: FC<DiaryFiltersAuthorsProps> = ({
  authors,
  ids,
  hideHeader,
  onAuthorClick
}) => {

  return (
    <DiaryFiltersItem>
      {!hideHeader && 
      <DiaryFiltersItemTitle>
        Сотрудник
      </DiaryFiltersItemTitle>
      }
      <DiaryFiltersAuthorsWrapper>
        {authors.map(author => {
          const avatar = author.profile.avatar?.id ? `/ecpp/attachments/files?attachmentId=${author.profile.avatar?.id}` : profileImg
          return (
            <SearchListItem key={author.id} $isActive={ids.includes(author.id)} onClick={() => onAuthorClick(author.id)}>
              <CheckIcon fill={ids.includes(author.id) ? COLORS.ACCENT.DEFAULT : undefined} />
              <img src={avatar} alt={author.id} />
              <span>{author.name.first}</span>
            </SearchListItem>
          )
        })}
      </DiaryFiltersAuthorsWrapper>
    </DiaryFiltersItem>
  )
}